import Leaflet from 'leaflet';
import marker from 'leaflet/dist/images/marker-icon.png';
import marker2x from 'leaflet/dist/images/marker-icon-2x.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';
import isBrowser from '@/utils/is-browser';

const icon = isBrowser
  ? Leaflet.icon({
      iconUrl: marker,
      iconRetinaUrl: marker2x,
      shadowUrl: shadow,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -24],
    })
  : undefined;

export default icon;
